// extracted by mini-css-extract-plugin
export default {"Container":"UpdateBook_Container__v8YGj","Created":"UpdateBook_Created__h-du9"};